import styled from 'styled-components';
import Link from 'gatsby-link';

const ReadMore = styled(Link)`    
    display: inline-block;
    border: 1px solid #888; 
    margin-top: 10px;
    padding: 5px 15px;
    color: #888;

    &:hover {
        color: #64AEDD;
        border-color: #64AEDD;
    }
`;

export default ReadMore;


// WEBPACK FOOTER //
// ./src/components/PostSummary/ReadMore.js